/**
 * Travel Ads 會員自服務與探索贊助標籤多國語系文案包
 */

export const travelAdsMessagesZhTW = {
  'travel.nav.ads': '廣告推廣',
  'travel.discover.sponsored': '贊助',
  'travel.ads.title': '廣告推廣',
  'travel.ads.myPromotions': '我的推廣',
  'travel.ads.myCreatives': '我的素材',
  'travel.ads.myCampaigns': '我的廣告活動',
  'travel.ads.tabs.promotions': '推廣申請',
  'travel.ads.tabs.creatives': '廣告素材',
  'travel.ads.tabs.campaigns': '廣告活動',
  'travel.ads.promotions.create': '新增推廣申請',
  'travel.ads.promotions.selectJourney': '選擇公開行程',
  'travel.ads.promotions.empty': '尚無推廣申請',
  'travel.ads.promotions.detail': '推廣申請詳情',
  'travel.ads.promotions.status': '推廣狀態',
  'travel.ads.promotions.source': '來源行程',
  'travel.ads.promotions.submit': '送出審核',
  'travel.ads.promotions.cancel': '取消推廣',
  'travel.ads.promotions.createCreative': '依此推廣建立素材',
  'travel.ads.promotions.rejectionReason': '駁回原因',
  'travel.ads.creatives.create': '新增廣告素材',
  'travel.ads.creatives.empty': '尚無廣告素材',
  'travel.ads.creatives.detail': '廣告素材詳情',
  'travel.ads.creatives.headline': '廣告標題',
  'travel.ads.creatives.summary': '廣告摘要',
  'travel.ads.creatives.edit': '編輯素材',
  'travel.ads.creatives.submit': '送出審核',
  'travel.ads.creatives.cancel': '取消素材',
  'travel.ads.creatives.status': '素材狀態',
  'travel.ads.creatives.rejectionReason': '駁回原因',
  'travel.ads.campaigns.create': '建立新廣告活動',
  'travel.ads.campaigns.empty': '尚無廣告活動',
  'travel.ads.campaigns.detail': '廣告活動詳情',
  'travel.ads.campaigns.status': '活動狀態',
  'travel.ads.campaigns.selectPromotion': '選擇已核准推廣',
  'travel.ads.campaigns.selectCreative': '選擇已核准素材',
  'travel.ads.campaigns.schedule': '排期設定',
  'travel.ads.campaigns.startAt': '開始時間',
  'travel.ads.campaigns.endAt': '結束時間',
  'travel.ads.campaigns.budget': '預算金額',
  'travel.ads.campaigns.currency': '幣別',
  'travel.ads.campaigns.targetingMode': '受眾定位模式',
  'travel.ads.campaigns.targetingAll': '全體用戶 (ALL)',
  'travel.ads.campaigns.targetingLocation': '地點比對 (LOCATION_MATCH)',
  'travel.ads.campaigns.prepare': '準備',
  'travel.ads.campaigns.activate': '啟用',
  'travel.ads.campaigns.pause': '暫停',
  'travel.ads.campaigns.cancel': '取消活動',
  'travel.ads.campaigns.suspendedNotice': '此活動已由管理員暫停，暫時無法操作',
  'travel.ads.billing.title': '帳務摘要',
  'travel.ads.billing.budget': '總預算',
  'travel.ads.billing.reserved': '保留額',
  'travel.ads.billing.paid': '已花費／扣款',
  'travel.ads.billing.hold': '帳務鎖定狀態',
  'travel.ads.billing.held': '鎖定中',
  'travel.ads.billing.normal': '正常',
  'travel.ads.reporting.title': '成效摘要',
  'travel.ads.reporting.impressions': '合格曝光',
  'travel.ads.reporting.clicks': '獨立點擊',
  'travel.ads.reporting.ctr': '點閱率 (CTR)',
  'travel.ads.conflictMessage': '內容已被修改，請重新整理',
  'travel.ads.common.refresh': '重新整理',
  'travel.ads.common.loading': '載入中…',
  'travel.ads.common.save': '儲存',
  'travel.ads.common.submitting': '處理中…',
  'travel.ads.common.backToAds': '返回廣告控制台',
  'travel.ads.status.DRAFT': '草稿',
  'travel.ads.status.SUBMITTED': '審核中',
  'travel.ads.status.APPROVED': '已核准',
  'travel.ads.status.REJECTED': '已駁回',
  'travel.ads.status.CANCELLED': '已取消',
  'travel.ads.status.READY': '就緒',
  'travel.ads.status.ACTIVE': '投放中',
  'travel.ads.status.PAUSED': '已暫停',
  'travel.ads.status.SUSPENDED': '管理員暫停',
};

export const travelAdsMessagesEnUS = {
  'travel.nav.ads': 'Ads',
  'travel.discover.sponsored': 'Sponsored',
  'travel.ads.title': 'Advertising',
  'travel.ads.myPromotions': 'My promotions',
  'travel.ads.myCreatives': 'My creatives',
  'travel.ads.myCampaigns': 'My campaigns',
  'travel.ads.tabs.promotions': 'Promotions',
  'travel.ads.tabs.creatives': 'Creatives',
  'travel.ads.tabs.campaigns': 'Campaigns',
  'travel.ads.promotions.create': 'New promotion',
  'travel.ads.promotions.selectJourney': 'Select public journey',
  'travel.ads.promotions.empty': 'No promotion applications yet',
  'travel.ads.promotions.detail': 'Promotion details',
  'travel.ads.promotions.status': 'Promotion status',
  'travel.ads.promotions.source': 'Source journey',
  'travel.ads.promotions.submit': 'Submit for review',
  'travel.ads.promotions.cancel': 'Cancel promotion',
  'travel.ads.promotions.createCreative': 'Create creative from this promotion',
  'travel.ads.promotions.rejectionReason': 'Rejection reason',
  'travel.ads.creatives.create': 'New creative',
  'travel.ads.creatives.empty': 'No ad creatives yet',
  'travel.ads.creatives.detail': 'Creative details',
  'travel.ads.creatives.headline': 'Headline',
  'travel.ads.creatives.summary': 'Summary',
  'travel.ads.creatives.edit': 'Edit creative',
  'travel.ads.creatives.submit': 'Submit for review',
  'travel.ads.creatives.cancel': 'Cancel creative',
  'travel.ads.creatives.status': 'Creative status',
  'travel.ads.creatives.rejectionReason': 'Rejection reason',
  'travel.ads.campaigns.create': 'New campaign',
  'travel.ads.campaigns.empty': 'No ad campaigns yet',
  'travel.ads.campaigns.detail': 'Campaign details',
  'travel.ads.campaigns.status': 'Campaign status',
  'travel.ads.campaigns.selectPromotion': 'Select approved promotion',
  'travel.ads.campaigns.selectCreative': 'Select approved creative',
  'travel.ads.campaigns.schedule': 'Schedule',
  'travel.ads.campaigns.startAt': 'Start time',
  'travel.ads.campaigns.endAt': 'End time',
  'travel.ads.campaigns.budget': 'Budget amount',
  'travel.ads.campaigns.currency': 'Currency',
  'travel.ads.campaigns.targetingMode': 'Targeting mode',
  'travel.ads.campaigns.targetingAll': 'All users (ALL)',
  'travel.ads.campaigns.targetingLocation': 'Location match (LOCATION_MATCH)',
  'travel.ads.campaigns.prepare': 'Prepare',
  'travel.ads.campaigns.activate': 'Activate',
  'travel.ads.campaigns.pause': 'Pause',
  'travel.ads.campaigns.cancel': 'Cancel campaign',
  'travel.ads.campaigns.suspendedNotice': 'This campaign was suspended by an administrator',
  'travel.ads.billing.title': 'Billing summary',
  'travel.ads.billing.budget': 'Total budget',
  'travel.ads.billing.reserved': 'Reserved amount',
  'travel.ads.billing.paid': 'Paid / spent',
  'travel.ads.billing.hold': 'Billing hold status',
  'travel.ads.billing.held': 'Held',
  'travel.ads.billing.normal': 'Normal',
  'travel.ads.reporting.title': 'Performance summary',
  'travel.ads.reporting.impressions': 'Qualified impressions',
  'travel.ads.reporting.clicks': 'Unique clicks',
  'travel.ads.reporting.ctr': 'Click-through rate (CTR)',
  'travel.ads.conflictMessage': 'Content was updated, please refresh',
  'travel.ads.common.refresh': 'Refresh',
  'travel.ads.common.loading': 'Loading…',
  'travel.ads.common.save': 'Save',
  'travel.ads.common.submitting': 'Processing…',
  'travel.ads.common.backToAds': 'Back to Ads Hub',
  'travel.ads.status.DRAFT': 'Draft',
  'travel.ads.status.SUBMITTED': 'Under review',
  'travel.ads.status.APPROVED': 'Approved',
  'travel.ads.status.REJECTED': 'Rejected',
  'travel.ads.status.CANCELLED': 'Cancelled',
  'travel.ads.status.READY': 'Ready',
  'travel.ads.status.ACTIVE': 'Active',
  'travel.ads.status.PAUSED': 'Paused',
  'travel.ads.status.SUSPENDED': 'Suspended',
};

export const travelAdsMessagesZhCN = {
  ...travelAdsMessagesZhTW,
  'travel.nav.ads': '广告推广',
  'travel.discover.sponsored': '赞助',
  'travel.ads.title': '广告推广',
  'travel.ads.myPromotions': '我的推广',
  'travel.ads.myCreatives': '我的素材',
  'travel.ads.myCampaigns': '我的广告活动',
  'travel.ads.tabs.promotions': '推广申请',
  'travel.ads.tabs.creatives': '广告素材',
  'travel.ads.tabs.campaigns': '广告活动',
  'travel.ads.promotions.create': '新增推广申请',
  'travel.ads.promotions.selectJourney': '选择公开行程',
  'travel.ads.promotions.empty': '暂无推广申请',
  'travel.ads.promotions.detail': '推广申请详情',
  'travel.ads.promotions.status': '推广状态',
  'travel.ads.promotions.source': '来源行程',
  'travel.ads.promotions.submit': '提交审核',
  'travel.ads.promotions.cancel': '取消推广',
  'travel.ads.promotions.createCreative': '依此推广建立素材',
  'travel.ads.promotions.rejectionReason': '驳回原因',
  'travel.ads.creatives.create': '新增广告素材',
  'travel.ads.creatives.empty': '暂无广告素材',
  'travel.ads.creatives.detail': '广告素材详情',
  'travel.ads.creatives.headline': '广告标题',
  'travel.ads.creatives.summary': '广告摘要',
  'travel.ads.creatives.edit': '编辑素材',
  'travel.ads.creatives.submit': '提交审核',
  'travel.ads.creatives.cancel': '取消素材',
  'travel.ads.creatives.status': '素材状态',
  'travel.ads.creatives.rejectionReason': '驳回原因',
  'travel.ads.campaigns.create': '建立新广告活动',
  'travel.ads.campaigns.empty': '暂无广告活动',
  'travel.ads.campaigns.detail': '广告活动详情',
  'travel.ads.campaigns.status': '活动状态',
  'travel.ads.campaigns.selectPromotion': '选择已核准推广',
  'travel.ads.campaigns.selectCreative': '选择已核准素材',
  'travel.ads.campaigns.schedule': '排期设定',
  'travel.ads.campaigns.startAt': '开始时间',
  'travel.ads.campaigns.endAt': '结束时间',
  'travel.ads.campaigns.budget': '预算金额',
  'travel.ads.campaigns.currency': '币别',
  'travel.ads.campaigns.targetingMode': '受众定位模式',
  'travel.ads.campaigns.targetingAll': '全体用户 (ALL)',
  'travel.ads.campaigns.targetingLocation': '地点匹配 (LOCATION_MATCH)',
  'travel.ads.campaigns.prepare': '准备',
  'travel.ads.campaigns.activate': '启用',
  'travel.ads.campaigns.pause': '暂停',
  'travel.ads.campaigns.cancel': '取消活动',
  'travel.ads.campaigns.suspendedNotice': '此活动已由管理员暂停，暂时无法操作',
  'travel.ads.billing.title': '账务摘要',
  'travel.ads.billing.budget': '总预算',
  'travel.ads.billing.reserved': '保留额',
  'travel.ads.billing.paid': '已花费／扣款',
  'travel.ads.billing.hold': '账务锁定状态',
  'travel.ads.billing.held': '锁定中',
  'travel.ads.billing.normal': '正常',
  'travel.ads.reporting.title': '成效摘要',
  'travel.ads.reporting.impressions': '合格曝光',
  'travel.ads.reporting.clicks': '独立点击',
  'travel.ads.reporting.ctr': '点击率 (CTR)',
  'travel.ads.conflictMessage': '内容已被修改，请重新整理',
  'travel.ads.common.refresh': '重新整理',
  'travel.ads.common.loading': '加载中…',
  'travel.ads.common.save': '保存',
  'travel.ads.common.submitting': '处理中…',
  'travel.ads.common.backToAds': '返回广告控制台',
};

const adsMessagesByLocale = {
  zh_TW: travelAdsMessagesZhTW,
  zh_HK: travelAdsMessagesZhTW,
  en_US: travelAdsMessagesEnUS,
  zh_CN: travelAdsMessagesZhCN,
};

export function getTravelAdsMessage(locale, key) {
  const dict = adsMessagesByLocale[locale] || adsMessagesByLocale.zh_TW || travelAdsMessagesZhTW;
  return dict[key] ?? travelAdsMessagesZhTW[key] ?? key;
}
